/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { loginUser } from '../api/authService';
import authManager from '../utils/authManager';

export const login = createAsyncThunk(
  'auth/login',
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const data = await loginUser(username, password);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message || 'Login failed' });
    }
  }
);

const initialState = {
	loading: false,
	error: null,
	mfaRequired: false,
	enrollmentRequired: false,
	tempSessionId: null,
	passkeyOptions: null,
	mfaEnforcement: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout(state) {
      Object.assign(state, initialState);
      authManager.logout();
    },
    clearLoginToken(state) {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.mfaRequired = false;
        state.enrollmentRequired = false;
        state.tempSessionId = null;
        state.passkeyOptions = null;
        state.mfaEnforcement = null;

        if (action.payload.mfa_required) {
          state.mfaRequired = true;
          state.tempSessionId = action.payload.temp_session_id;
          state.passkeyOptions = action.payload.passkey_options;
        } 
        else if (action.payload.enrollment_required) {
          state.enrollmentRequired = true;
          state.mfaEnforcement = action.payload.admin?.mfa_enforcement || 'mandatory';
        }
      })
      .addCase(login.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { logout, clearLoginToken } = authSlice.actions;
export default authSlice.reducer;
